module.exports = __webpack_public_path__ + "img/nz.dc9643d4.svg";